module.exports = __webpack_public_path__ + "img/in-use-nan-young-kim@2x.5bb82ccb.jpg";